import { useMutation } from "@tanstack/react-query";
import { updateUserInfo } from "../../../api/request/updateUserInfo";
import { useNotificationStore } from "@src/shared/components/Notification";
import { AxiosError } from "axios";

export const useUpdateUserInfo = () => {
  const { showAlert } = useNotificationStore();

  const query = useMutation({
    mutationFn: updateUserInfo,
    onSuccess: () => {
      showAlert("Данные успешно обновлены", "success");
    },
    onError: (error: AxiosError) => {
      const response = error?.response?.data as { detail: string };
      const detail = response?.detail || "";

      if (detail.includes("email") || detail.includes("phone")) {
        showAlert(
          "Пользователь с такой почтой или телефоном уже зарегистрирован",
          "error"
        );
        return;
      }
      showAlert(error.message, "error");
    },
  });
  return query;
};
